export { default as LogoWhiteSvg } from './logo-white.svg';
export { default as LogoSvg } from './logo.svg';
